import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';
import { PersonalComponent } from './components/personal/personal.component';
import { MatIconModule } from '@angular/material/icon';
import { ActionModule } from '../../admin/action/action.module';
import { BusinessComponent } from './components/business/business.component';
import { MigrationComponent } from './components/migration/migration.component';
import { CashApiComponent } from './components/cash-api/cash-api.component';
import { AuthGuardService as AuthGuard } from '../../../shared/services/auth.guard';
import { CreditCardRequestFormComponent } from './components/credit-card-request-form/credit-card-request-form.component';
import { MatRadioModule } from '@angular/material/radio';
import { ViewRequestComponent } from './components/view-request/view-request.component';
import { ContractComponent } from './components/contract/contract.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NewActivationPageComponent } from './components/new-activation-page/new-activation-page.component';
import { PermissionsGuardService } from 'src/app/shared/services/permissions-guard.service';
import { RoleGuardService } from 'src/app/shared/services/role-guard.service';
import { CustomPaymentBuyerIfnoSettingComponent } from './components/custom-payment-buyer-ifno-setting/custom-payment-buyer-ifno-setting.component';
import { DocumentDisplayComponent } from './components/credit-card-request-form/document-display/document-display.component';
const myAccountRoutes: Routes = [
  {
    path: 'business',
    component: NewActivationPageComponent,
    canActivate: [RoleGuardService, PermissionsGuardService, AuthGuard],
    data: {
      expectedRole: 'Seller',
    },
  },
  { path: 'migration', component: MigrationComponent },
  {
    path: 'customPayment',
    component: CustomPaymentBuyerIfnoSettingComponent,
    canActivate: [AuthGuard,PermissionsGuardService],
  },
  { path: 'cash-api', component: CashApiComponent },
  {
    path: 'requestActivation/:id',
    component: ViewRequestComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'personal',
    component: PersonalComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'contract/:id',
    component: ViewRequestComponent,
    canActivate: [AuthGuard],
    data: {
      isContract: true,
    },
  },
];

@NgModule({
  declarations: [
    PersonalComponent,
    BusinessComponent,
    MigrationComponent,
    CashApiComponent,
    CreditCardRequestFormComponent,
    ViewRequestComponent,
    ContractComponent,
    CustomPaymentBuyerIfnoSettingComponent,
    DocumentDisplayComponent,
    //ViewCreditCardRequestComponent,
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(myAccountRoutes),
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatRadioModule,
    ActionModule,
    MatTabsModule,
    MatDialogModule
  ],
  providers: [
    { provide: MAT_DIALOG_DATA, useValue: {} },
    { provide: MatDialogRef, useValue: {} }
  ]
})
export class MyAccountModule { }
